import {TranslatableRental} from "./locations";
import {mainPhotoStudio, studioPhotos} from "./photo";
import {studioFR} from "./descriptions/fr/studio";
import {studioEN} from "./descriptions/en/studio";



export const studio2: TranslatableRental = {
  roomId: "501223",
  slugs: {
    fr: "appartement-vue-jardin-numero-2",
    en: "garden-view-apartment-number-2"
  },
  name: {
    fr: "Appartement - Vue jardin",
    en: "Apartment - Garden View"
  },
  description: {
    fr: studioFR,
    en: studioEN
  },
  area: 33,
  capacity: 2,
  numberOfBeds: 1,
  numberOfBedrooms: 1,
  numberOfBathrooms: 1,
  equipments: [
    "ac",
    "tv",
    "wifi",
    "breakfast",
    "coffee-machine",
    "fridge",
    "heater",
    "kitchen-storage",
    "swimming",
    "toilet",
    "shower",
    "wheelchair-way",
    "parking",
    "kettle",
    "microwave",
    "no-smoking",
    "hair-dryer",
    "iron",
    "household-linen",
    "toaster"
  ],
  lodgifyId: "435086",
  mainImage: mainPhotoStudio,
  assets: studioPhotos
}
